import { DaysCheckBoxInput } from "@/components/dayscheckboxgroup";
import { Typography, Grid, Box } from "@mui/material";
import {
  Create,
  DateInput,
  ImageField,
  ImageInput,
  minValue,
  NumberInput,
  required,
  SimpleForm,
  TextInput,
  useTranslate,
} from "react-admin";
import { useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const BogoFormFields = () => {
  const translate = useTranslate();
  const today = new Date().toISOString().split("T")[0];
  const startAt = useWatch({ name: "start_at" });

  const computeMinEndAt = () => {
    if (!startAt) return "";
    const date = new Date(startAt);
    if (isNaN(date.getTime())) return "";

    date.setDate(date.getDate() + 7);
    return date.toISOString().split("T")[0];
  };

  const minEndAt = computeMinEndAt();

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <ImageInput
          source="file"
          accept={{ "image/*": [".png", ".jpg", ".jpeg"] }}
          placeholder={translate("ra.gameoo.voucherThumbnailPlaceHolder")}
          multiple={false}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
        <Grid container spacing={3}>
          <Grid size={6}>
            {" "}
            <Typography>Nom du produit acheté</Typography>
            <TextInput
              source="product_purchased"
              label="Nom de produit"
              validate={[required()]}
            />
          </Grid>
          <Grid size={6}>
            <Typography>Valeur du produit acheté</Typography>
            <NumberInput
              source="product_purchased_value"
              label="Montant (en Ariary)"
              validate={[required(), minValue(3000)]}
              min={3000}
              step={1}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid size={6}>
            <Typography>Nom produit offert</Typography>
            <TextInput
              source="item"
              label="Nom de produit"
              validate={[required()]}
            />
          </Grid>
          <Grid size={6}>
            <Typography>Valeur du produit offert</Typography>
            <NumberInput
              source="discount_value"
              label="Montant (en Ariary)"
              validate={[required(), minValue(3000)]}
              min={3000}
              step={1}
            />
          </Grid>
        </Grid>
      </Box>
      <Typography>Quantité</Typography>
      <NumberInput
        source="quantity"
        label="Quantité"
        validate={[required(), minValue(1)]}
        min={1}
        step={1}
      />
      <Typography>Date de validité</Typography>
      <DateInput
        source="start_at"
        label="Début"
        validate={[required()]}
        slotProps={{
          input: {
            inputProps: {
              min: today,
            },
          },
        }}
      />
      <Typography>Au</Typography>
      <DateInput
        source="end_at"
        label="Fin"
        validate={[required()]}
        slotProps={{
          input: {
            inputProps: {
              min: minEndAt || today,
            },
          },
        }}
      />
      <Typography>Jour de validité</Typography>
      <DaysCheckBoxInput source="day_validity" validate={[required()]} />
    </>
  );
};

const BogoCreate = () => {
  const navigate = useNavigate();

  return (
    <Create
      transform={(data) => ({
        ...data,
        voucher_type: "bogo",
        product_purchased_value: +data.product_purchased_value,
        discount_type: "fixed",
      })}
      mutationOptions={{
        onSuccess: () => {
          navigate("/vouchers");
        },
      }}
    >
      <SimpleForm>
        <BogoFormFields />
      </SimpleForm>
    </Create>
  );
};

export default BogoCreate;
